import React from "react";
import ReactEcharts from "echarts-for-react";

export function HorizontalZoomBarChart({ dados, style, grid = false }) {
  let mobile = window.innerWidth <= 618;
  let iPad = window.innerWidth <= 880;
  let iPadMini = window.innerWidth <= 700;

  const option = {
    grid: {
      left: "3%",
      right: window.innerWidth <= 661 ? "10%" : "7%",
      bottom: "3%",
      top: "5%",
      containLabel: true,
    },
    xAxis: {
      type: "value",
      axisLine: {
        show: true,
      },
      axisLabel: {
        fontSize: 10,
        fontWeight: 600,
        formatter: (value) => {
          return "" + value + "%";
        },
      },
      max: 100,
      boundaryGap: [0, 0.01],
      interval: 100 / 4,
    },
    yAxis: {
      type: "category",
      inverse: true,
      axisLabel: {
        show: false,
      },
      //  fontWeight: 'bold',
      //  fontSize: 10,
      //  width: window.innerWidth <= 700 ? 180 : '100%',
      //  align: 'left',
      //  overflow: 'break',
      //  //backgroundColor: '#FFF',
      //  //borderRadius: 2,
      //  textBorderColor: '#fff',
      //  textBorderWidth: 3,
      //  padding: [1, 1, 1, 1],
      //  elipsis: '...',
      //  lineHeight: 11,
      //},
      z: 10,
      axisTick: {
        alignWithLabel: false,
      },
    },
    dataZoom: [
      {
        start: 50,
        end: 0,
        orient: "vertical",
        zoomOnMouseWheel: true,
        zoomLock: false,
        minSpan: 50,
        show: true,
        yAxisIndex: 0,
        filterMode: "empty",
        width: "5%",
        handleSize: 30,
        textStyle: {
          fontSize: 0,
        },
      },
    ],
    //visualMap: {
    //  orient: 'horizontal',
    //  left: 'center',
    //  type: 'continuous',
    //  show: false,
    //  min: data.dados.length - 1,
    //  max: 0,
    //  text: ['High Score', 'Low Score'],
    //},
    series: [
      {
        //seriesLayoutBy: 'column',
        type: "bar",
        stack: "chart",
        silent: false,
        barCategoryGap: 30,
        barWidth: "90%",
        itemStyle: {
          color: "#90cbf0",
        },
        label: {
          show: true,
          formatter: (params) => {
            /*const value = `${params.value.quantidade}`.replace(
              /(\d{1,3})(?=(?:\d{3})+(?!\d))/g,
              '$1.'
            );*/
            return params.name;
          },
          position: "insideLeft",
          align: "left",
          fontWeight: "bold",
          overflow: "break",
          fontSize: mobile
            ? 9
            : iPadMini
            ? "1.2rem"
            : iPad && grid
            ? 9
            : "1.3rem",
          lineHeight: 10,
          width: mobile
            ? window.innerWidth * 0.45
            : iPadMini
            ? "100%"
            : grid
            ? window.innerWidth * 0.18
            : "100%",
          rich: {
            name: {},
          },
        },
        data: dados,
      },
      {
        type: "bar",
        stack: "chart",
        silent: true,
        itemStyle: {
          color: "whitesmoke",
        },
        label: {
          position: "insideRight",
          show: true,
          silent: true,
          formatter: (params) => {
            const value = `${(dados[0].value + 100 - params.value).toFixed(
              2
            )}%`;
            return value;
          },
        },
        data: dados.map((obj) => {
          return dados[0].value + 100 - obj.value;
        }),
      },
    ],
  };

  return <ReactEcharts option={option} style={style} />;
}
